import { render, staticRenderFns } from "./ApfEmailVerificationModal.vue?vue&type=template&id=37d9fda9"
import script from "./ApfEmailVerificationModal.vue?vue&type=script&lang=js"
export * from "./ApfEmailVerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports